import type { FC } from 'react'
import { lazy } from 'react'
import { retryImport } from 'utils/retryImport'

type ScreenProps = { [key: string]: unknown }

export const adminScreenLoader = (
  screen: string,
  screenProps: ScreenProps = {}
) => {
  return lazy(() => {
    const screens = retryImport(() => import('screens/admin')).then(s => {
      const Screen = s[screen] as FC

      Screen.defaultProps = { ...(Screen.defaultProps || {}), ...screenProps }

      return { default: Screen }
    })

    return screens
  })
}

export const siteScreenLoader = (screen: string, screenProps?: ScreenProps) => {
  return lazy(() => {
    const screens = retryImport(() => import('screens/site')).then(s => {
      const Screen = s[screen] as FC

      Screen.defaultProps = { ...(Screen.defaultProps || {}), ...screenProps }

      return { default: Screen }
    })

    return screens
  })
}

export const clientManagementScreenLoader = (
  screen: string,
  screenProps?: ScreenProps
) => {
  return lazy(() => {
    const screens = retryImport(() => import('screens/client-management')).then(
      s => {
        const Screen = s[screen] as FC

        Screen.defaultProps = { ...(Screen.defaultProps || {}), ...screenProps }

        return { default: Screen }
      }
    )

    return screens
  })
}
